import { LoginCallback as OktaLoginCallback } from "@okta/okta-react";

function CallbackError({ error }: { error: Error }) {
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <p className="subtitle">Authentication Error</p>
        </div>
        <div className="alert alert-danger" role="alert">
          <i className="fa fa-exclamation-triangle" />
          {error.message}
        </div>
      </div>
    </div>
  );
}

export function LoginCallback() {
  return <OktaLoginCallback errorComponent={CallbackError} />;
}
